import EntityAppService from '../../../../application/platform/scp/entity/entitiy-app-service';
import { useActionRunner } from '../../../../hooks/use-action-runner';
import { IUnidEntityAddRequest } from '../../../../model/scp/entity/request/unid-entity-add-request';
import { ACTION_TYPES, useUnidEntitySearchDispatch } from './unid-entity-search-context';

// A API de unidades só permite listar e incluir (sem filtros, edição ou exclusão)
export const useUnidEntitySearchController = () => {
    const dispatch = useUnidEntitySearchDispatch();
    const { isSaving, runSaving, showSuccess } = useActionRunner();

    function openDrawer() {
        dispatch({ type: ACTION_TYPES.openDrawer });
    }

    function closeDrawer() {
        dispatch({ type: ACTION_TYPES.closeDrawer });
    }

    function handleSave(request: IUnidEntityAddRequest) {
        if (isSaving) return;
        runSaving('Não foi possível salvar a unidade', async () => {
            await EntityAppService.addUnidEntity(request);
            showSuccess('Unidade cadastrada com sucesso!');
            closeDrawer();
            dispatch({ type: ACTION_TYPES.triggerSearch });
        });
    }

    return { isSaving, openDrawer, closeDrawer, handleSave };
};
